import { types as orderTypes } from 'redux/order/reducer';
import { createSymbols } from 'utils/helpers';
import { mapOrder } from 'utils/mapToRecord';
import { collectionReducer } from 'utils/reducerGenerator';

export const {
    DOWNLOAD_SELECTED_ORDERS,
    DOWNLOAD_SELECTED_ORDERS_FAIL,
    DOWNLOAD_SELECTED_ORDERS_SUCCESS,
} = createSymbols([
    'DOWNLOAD_SELECTED_ORDERS',
    'DOWNLOAD_SELECTED_ORDERS_FAIL',
    'DOWNLOAD_SELECTED_ORDERS_SUCCESS',
]);

const updateOrderSuccess = (state, { payload }) => {
    const order = mapOrder(payload.data);

    return state.set(
        'data',
        state.get('data').map((item) => {
            if (item.get('id') === order.get('id')) {
                return order;
            }

            return item;
        })
    );
};

export const { reducer, types } = collectionReducer(
    { namespace: 'ORDER', transformer: mapOrder },
    {
        [orderTypes.PATCH_SUCCESS]: updateOrderSuccess,
        [orderTypes.PUT_SUCCESS]: updateOrderSuccess,
    }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/orders/reducer.js